import { render, staticRenderFns } from "./SpaceTypeFilterMenu.vue?vue&type=template&id=2756d814&"
import script from "./SpaceTypeFilterMenu.vue?vue&type=script&lang=js&"
export * from "./SpaceTypeFilterMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports